import { useState } from "react";

import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useContentDataMapping(isFirstLogin: boolean, enableIntroVideo: boolean) {
    let { data: videoLink } = useDotLegalQueryWithKey<string>("introVideoLink", "/videolink/intro", {
        enabled: isFirstLogin && enableIntroVideo,
    });

    const [showIntroVideo, setShowIntroVideo] = useState(isFirstLogin && enableIntroVideo);

    return {
        videoLink,
        showIntroVideo,
        setShowIntroVideo,
    };
}
